import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'view-design'
import 'view-design/dist/styles/iview.css'
import { isMobile } from '@libs/util'
import store from './store'
import '@babel/polyfill'


Vue.use(iView)

let theme
if (isMobile()) {
  theme = () => import('@theme/_iview-mobile.scss')
} else {
  theme = () => import('@theme/_iview.scss')
}

theme()

Vue.config.productionTip = false

Vue.prototype.$config = window.config

store.dispatch('globalInit')

const bootstrap = async () => {
  await store.dispatch('setUser')
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}
bootstrap()
